import { share, ignoreElements } from 'rxjs/operators';
import canUseDom from '@clearscore/helpers.can-use-dom';

import filterEvents from './filterEvents';
import createSegmentTransformer from './segment/transformer';
import segmentObserver from './segment/observer';

/**
 * Epic to listen to all redux actions and handle any action with associated tracking events
 * @param {Observable} action$ observable of redux actions
 * @param {Observable} state$ observable
 * @returns {Observable} observable with empty values
 */
const setupTrackingEpic = (trackingEventConfig) =>
    function trackingEpic(action$, state$) {
        const event$ = action$.pipe(filterEvents(trackingEventConfig), share());

        // tracking needs the window and is for client-side only
        if (canUseDom()) {
            event$.pipe(createSegmentTransformer(state$)).subscribe(segmentObserver);
        }

        return event$.pipe(ignoreElements());
    };

export default setupTrackingEpic;
